@if (!isEditMode) {
    <div>
        @if (descriptor.descriptor.fieldTypeID == FieldTypeEnum.Currency) {
            <span
            >{{ descriptor.value | currency: 'USD' }}</span>
        }
        @if (descriptor.descriptor.fieldTypeID == FieldTypeEnum.Text) {
            <span>
                @if (descriptor.value || descriptor.value === 0) {
                    <span>{{ descriptor.value }}</span>
                }
                @if (!(descriptor.value || descriptor.value === 0)) {
                    <span>Empty</span>
                }
            </span>
        }
        @if (descriptor.descriptor.fieldTypeID == FieldTypeEnum.Number) {
            <span>
                @if (descriptor.value || descriptor.value === 0) {
                    <span>
                        @if (descriptor.descriptor.formatID == DescriptorFormats.NoSeparators || !descriptor.descriptor.formatID) {
                            <span>{{ descriptor.value }}</span>
                        }
                        @if (descriptor.descriptor.formatID == DescriptorFormats.CommaSeparators || descriptor.descriptor.formatID == DescriptorFormats.CommaSeparatorsDupe) {
                            <span>{{ descriptor.value | number }}</span>
                        }
                        @if (descriptor.descriptor.formatID == DescriptorFormats.CommaSeparatorsPrecision2) {
                            <span>{{ descriptor.value | number: '1.2-2' }}</span>
                        }
                        @if (descriptor.descriptor.formatID == DescriptorFormats.CommaSeparatorsPrecision3) {
                            <span>{{ descriptor.value | number: '1.3-3' }}</span>
                        }
                    </span>
                }
                @if (!(descriptor.value || descriptor.value === 0)) {
                    <span>Empty</span>
                }
            </span>
        }
        @if (descriptor.descriptor.fieldTypeID == FieldTypeEnum.Date) {
            <span>
                @if (!descriptor.value) {
                    <span>Empty</span>
                }
                @if (descriptor.value) {
                    <weissman-datetime [(inputDate)]="descriptor.value"
                                       [dateOnly]="true"
                                       [readOnly]="true">
                    </weissman-datetime>
                }
            </span>
        }
        @if (descriptor.descriptor.fieldTypeID == FieldTypeEnum.YesNo) {
            <span>{{ descriptor.value ? 'Yes' : 'No' }}</span>
        }
        @if (descriptor.descriptor.fieldTypeID == FieldTypeEnum.Picklist) {
            <span>{{ descriptor.value || 'Not Set' }}</span>
        }
    </div>
}

@if (isEditMode) {
    <div>
        @if (descriptor.descriptor.fieldTypeID == FieldTypeEnum.Currency) {
            <input [(ngModel)]="descriptor.value"
                   [class.ng-invalid]="!isValid"
                   [class.ng-touched]="wasSaveAttempted"
                   [disabled]="disabled"
                   [options]="{ allowNegative: true, precision: 2 }"
                   class="form-control"
                   currencyMask
                   required
                   type="text">
        }
        @if (descriptor.descriptor.fieldTypeID == FieldTypeEnum.Text) {
            <input [(ngModel)]="descriptor.value"
                   [attr.maxLength]="descriptor.descriptor.validation.maxLength > 0 ? descriptor.descriptor.validation.maxLength : null"
                   [class.ng-invalid]="!isValid"
                   [class.ng-touched]="wasSaveAttempted"
                   [disabled]="disabled"
                   class="form-control"
                   required
                   type="text">
        }
        @if (descriptor.descriptor.fieldTypeID == FieldTypeEnum.Number) {
            <input [(ngModel)]="descriptor.value"
                   [attr.max]="descriptor.descriptor.validation.maxValue > 0 ? descriptor.descriptor.validation.maxValue : null"
                   [attr.min]="descriptor.descriptor.validation.minValue > 0 ? descriptor.descriptor.validation.minValue : null"
                   [class.ng-invalid]="!isValid"
                   [class.ng-touched]="wasSaveAttempted"
                   [disabled]="disabled"
                   [options]="numberOptions"
                   class="form-control"
                   currencyMask
                   required
                   type="text">
        }
        @if (descriptor.descriptor.fieldTypeID == FieldTypeEnum.Date) {
            <weissman-datetime [(inputDate)]="descriptor.value"
                               [dateOnly]="true"
                               [excludeValidation]="true"
                               [isDisabled]="disabled"
                               [required]="true"
                               [setInvalid]="!isValid">
            </weissman-datetime>
        }
        @if (descriptor.descriptor.fieldTypeID == FieldTypeEnum.YesNo) {
            <div class="checkbox">
                <label>
                    <input [(ngModel)]="descriptor.value" [disabled]="disabled" type="checkbox">
                </label>
            </div>
        }
        @if (descriptor.descriptor.fieldTypeID == FieldTypeEnum.Picklist) {
            <select [(ngModel)]="descriptor.value"
                    [class.ng-invalid]="!isValid"
                    [class.ng-touched]="wasSaveAttempted"
                    [disabled]="disabled"
                    class="form-select form-select-sm"
                    required>
                @for (option of picklistOptions; track option) {
                    <option [ngValue]="option.name">{{ option.name }}</option>
                }
            </select>
        }
    </div>
}
